import styled from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';
import { ShapedIcon, Text } from 'components/common';
import { MEDIA_MEDIUM } from 'constants/common';
import * as typography from 'components/mixins/typography';
import { getCustomScrollbars } from 'components/mixins/customScrollbars';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-width: 0;
  min-height: 100vh;
  max-height: 100%;
  ${getCustomScrollbars()};
  ${media.tablet`
    height: auto;
  `};
  @media (max-width: ${MEDIA_MEDIUM - 24}px) {
    flex: 0 0 auto;
    min-height: 0;
  }
`;

export const CourseInfoContainer = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 120px 80px 64px;
  ${media.tablet`
    height: auto;
  `};
  ${media.mobile`
    padding: 80px 30px;
  `};
`;

export const CourseInfoWrapper = styled.div`
  max-width: 880px;
  margin: 0 auto;
  ${media.xlarge`
    max-width: 700px;
  `}
`;

export const ContentsContainer = styled.div`
  width: 100%;

  h2,
  h3,
  h4 {
    margin-top: 0;
  }
`;

export const IntroductionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 16px;
`;

export const IntroductionTitle = styled(Text)`
  flex: 1 1 80%;
  ${typography.secondaryFontText};
  ${typography.bold};
`;

export const IntroductionIcon = styled(ShapedIcon)`
  margin-right: 16px;
  border: 2px solid ${props => transparentize(props.theme.colors.coverBgOverlayTextColor, 0.7)};
  ${media.mobile`
    margin-right: 15px;
  `};
`;

export const LogoWrapper = styled.div`
  margin-bottom: 40px;
`;

export const CourseLogo = styled.img.attrs({
  src: props => props.logoUrl,
  alt: props => props.alt
})`
  max-width: 240px;
  max-height: 100px;

  ${media.tablet`
    max-width: 200px;
    max-height: 80px;
  `};

  ${media.mobile`
    max-width: 160px;
    max-height: 60px;
  `};
`;
